const sampleDataKey = {
    string: 'Some string',
    integer: 12,
    number: 3.14159,
    date: '2022-01-01',
    jsDate: new Date('2022-01-01 12:00:00'),
    Date: new Date('2022-01-01 12:00:00'),
    boolean: true
}

const sampleData = (definition, topLevel = true) => {
    if (definition.__array__) {
        if (typeof definition.__array__ === 'string') return [sampleDataKey[definition.__array__]]
        return [sampleData(definition.__array__, false)]
    }
    const def = definition.__obj__ || definition
    if ((topLevel && typeof definition === 'object') || definition.__obj__) return Object.keys(def).reduce((acc, key) => {
        acc[key] = sampleData(def[key], false);
        return acc;
    }, {})
    const key = definition.format || definition.type || definition.instanceof || definition.nullableinstanceof;
    if (key && !topLevel) return sampleDataKey[key] || sampleDataKey[key[0]];
    return sampleDataKey[definition];
}

export default sampleData